<template>
  <div class="box">
    <Echart
      id="centreLeft2Chart"
      ref="centreLeft2ChartRef"
      :options="options"
      height="640px"
      width="800px"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'chart',
  data() {
    return {
      options: {},
    }
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        // 设置点的位置(经纬度)
        const geoCoordMap = {
          湖州市: [120.102398, 30.867198, 20],
          嘉兴市: [120.750865, 30.762653, 20],
          杭州市: [120.153576, 30.287459, 20],
          绍兴市: [120.582112, 29.997117, 20],
          宁波市: [121.549792, 29.868388, 20],
          衢州市: [118.87263, 28.941708, 20],
          金华市: [119.649506, 29.089524, 20],
          台州市: [121.428599, 28.661378, 20],
          丽水市: [119.921786, 28.451993, 20],
          温州市: [120.672111, 28.000575, 20],
          舟山市: [122.106863, 30.016028, 20],
        }
        let seriesData = [
          {
            name: '湖州市',
          },
          {
            name: '嘉兴市',
          },
          {
            name: '杭州市',
          },
          {
            name: '绍兴市',
          },
          {
            name: '宁波市',
          },
          {
            name: '衢州市',
          },
          {
            name: '金华市',
          },
          {
            name: '台州市',
          },
          {
            name: '丽水市',
          },
          {
            name: '温州市',
          },
          {
            name: '舟山市',
          },
        ]
        let convertData = function (data) {
          let scatterData = []
          for (var i = 0; i < data.length; i++) {
            var geoCoord = geoCoordMap[data[i].name]
            if (geoCoord) {
              scatterData.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].value),
              })
            }
          }
          return scatterData
        }
        this.options = {
          showLegendSymbol: true,
          tooltip: {
            trigger: 'item',
            textStyle: {
              fontSize: 14,
              lineHeight: 22,
            },
            position: (point) => {
              // 固定在顶部
              return [point[0] + 50, point[1] - 20]
            },
            // 如果需要自定义 tooltip样式，需要使用formatter
            /*
              formatter: params => {
                return `<div style=""> ... </div>`
              }
            */
          },
          visualMap: {
            min: 0,
            max: 10,
            show: false,
            seriesIndex: 0,
            // 颜色
            inRange: {
              color: ['rgba(41,166,206, .5)', 'rgba(69,117,245, .9)'],
            },
          },
          // 底部背景
          geo: [
            {
              show: true,
              aspectScale: 0.85, //长宽比
              zoom: 1,
              top: '10%',
              left: '15%',
              map: '浙江',
              roam: false,
              itemStyle: {
                normal: {
                  areaColor: '#01215c',
                  shadowColor: 'rgba(0,54,255, 1)',
                  borderColor: 'rgba(0,242,252,.3)',
                  borderWidth: '2',
                  shadowBlur: 200,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                },
                emphasis: {
                  areaColor: 'red',
                },
              },
            },
            // {
            //   show: true,
            //   aspectScale: 0.85, //长宽比
            //   zoom: 1,
            //   top: '10%',
            //   left: '16%',
            //   map: '浙江',
            //   roam: false,
            //   itemStyle: {
            //     normal: {
            //       areaColor: 'rgba(0,0,0,0)',
            //       shadowColor: 'rgba(14,114,204, .8)',
            //       borderWidth: '1',
            //       shadowOffsetX: 5,
            //       shadowOffsetY: 6,
            //     },
            //     emphasis: {
            //       areaColor: '#00aeef',
            //     },
            //   },
            // },
            {
              show: true,
              aspectScale: 0.85, //长宽比
              zoom: 1,
              top: '10%',
              left: '15%',
              map: '浙江',
              roam: false,
              itemStyle: {
                normal: {
                  areaColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(7,114,204, .8)',
                  borderWidth: '1',
                  shadowBlur: '4', //地图模糊
                  shadowOffsetX: 2,
                  shadowOffsetY: 8,
                },
                emphasis: {
                  areaColor: '#00aeef',
                },
              },
            },
            {
              show: true,
              aspectScale: 0.85, //长宽比
              zoom: 1,
              top: '10%',
              left: '15%',
              map: '浙江',
              roam: false,
              itemStyle: {
                normal: {
                  areaColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(7,114,204, .8)',
                  borderWidth: '1',
                  shadowBlur: '4', //地图模糊
                  shadowOffsetX: 2,
                  shadowOffsetY: 10,
                },
                emphasis: {
                  areaColor: '#00aeef',
                },
              },
            },
            {
              show: true,
              aspectScale: 0.85, //长宽比
              zoom: 1,
              top: '10%',
              left: '15%',
              map: '浙江',
              roam: false,
              itemStyle: {
                normal: {
                  areaColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(7,114,204, .8)',
                  borderWidth: '1',
                  shadowBlur: '4', //地图模糊
                  shadowOffsetX: 2,
                  shadowOffsetY: 13,
                },
                emphasis: {
                  areaColor: '#00aeef',
                },
              },
            },
            {
              show: true,
              aspectScale: 0.85, //长宽比
              zoom: 1,
              top: '10%',
              left: '15%',
              map: '浙江',
              roam: false,
              itemStyle: {
                normal: {
                  areaColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(7,114,204, .8)',
                  borderWidth: '1',
                  shadowBlur: '4', //地图模糊
                  shadowOffsetX: 2,
                  shadowOffsetY: 16,
                },
                emphasis: {
                  areaColor: '#00aeef',
                },
              },
            },
            {
              show: true,
              aspectScale: 0.85, //长宽比
              zoom: 1,
              top: '10%',
              left: '15%',
              map: '浙江',
              roam: false,
              itemStyle: {
                normal: {
                  areaColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(7,114,204, .8)',
                  borderWidth: '1',
                  shadowBlur: '2', //地图模糊
                  shadowOffsetX: 2,
                  shadowOffsetY: 10,
                },
                emphasis: {
                  areaColor: '#00aeef',
                },
              },
            },
            {
              show: true,
              aspectScale: 0.85, //长宽比
              zoom: 1,
              top: '10%',
              left: '15%',
              map: '浙江',
              roam: false,
              itemStyle: {
                normal: {
                  areaColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(7,114,204, .8)',
                  borderWidth: '1',
                  shadowBlur: '4', //地图模糊
                  shadowOffsetX: 2,
                  shadowOffsetY: 19,
                },
                emphasis: {
                  areaColor: '#00aeef',
                },
              },
            },
            {
              show: true,
              aspectScale: 0.85, //长宽比
              zoom: 1,
              top: '10%',
              left: '15%',
              map: '浙江',
              roam: false,
              itemStyle: {
                normal: {
                  areaColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(7,114,204, .8)',
                  borderWidth: '1',
                  shadowBlur: '4', //地图模糊
                  shadowOffsetX: 2,
                  shadowOffsetY: 22,
                },
                emphasis: {
                  areaColor: '#00aeef',
                },
              },
            },
            {
              show: true,
              aspectScale: 0.85, //长宽比
              zoom: 1,
              top: '10%',
              left: '15%',
              map: '浙江',
              roam: false,
              itemStyle: {
                normal: {
                  areaColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(7,114,204, .8)',
                  borderWidth: '1',
                  // shadowBlur: '4', //地图模糊
                  shadowOffsetX: 2,
                  shadowOffsetY: 22,
                },
                emphasis: {
                  areaColor: '#00aeef',
                },
              },
            },
          ],
          series: [
            {
              name: '相关指数',
              type: 'map',
              aspectScale: 0.85, //长宽比
              zoom: 1,
              mapType: '浙江', // 自定义扩展图表类型
              top: '10%',
              left: '15%',
              itemStyle: {
                normal: {
                  color: 'red',
                  areaColor: 'rgba(19,54,162, .1)',
                  borderColor: 'rgba(0,242,252,.3)',
                  borderWidth: 1,
                  shadowBlur: 7,
                  shadowColor: '#00f2fc',
                },
                emphasis: {
                  areaColor: '#4f7fff',
                  borderColor: 'rgba(0,242,252,.6)',
                  borderWidth: 2,
                  shadowBlur: 10,
                  shadowColor: '#00f2fc',
                },
              },
              label: {
                formatter: (params) => `${params.name}`,
                show: true,
                position: 'insideRight',
                textStyle: {
                  fontSize: 14,
                  color: '#00f2fc',
                },
                emphasis: {
                  textStyle: {
                    color: '#fff',
                  },
                },
              },
              data: newData,
            },
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              symbolSize: 7,
              effectType: 'ripple',
              legendHoverLink: false,
              showEffectOn: 'render',
              rippleEffect: {
                period: 9,
                scale: 2.5,
                brushType: 'stroke',
              },
              zlevel: 1,
              itemStyle: {
                normal: {
                  color: '#99FBFE',
                  shadowBlur: 5,
                  shadowColor: '#fff',
                },
              },
              data: convertData(seriesData),
            },
          ],
        }
        // 重新选择区域
        // this.handleMapRandomSelect()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // // 开启定时器
    // startInterval() {
    //   const _self = this
    //   // 应通过接口获取配置时间，暂时写死5s
    //   const time = 2000
    //   if (this.intervalId !== null) {
    //     clearInterval(this.intervalId)
    //   }
    //   this.intervalId = setInterval(() => {
    //     _self.reSelectMapRandomArea()
    //   }, time)
    // },
    // // 重新随机选中地图区域
    // reSelectMapRandomArea() {
    //   const length = 9
    //   this.$nextTick(() => {
    //     try {
    //       const map = this.$refs.centreLeft2ChartRef.chart
    //       let index = Math.floor(Math.random() * length)
    //       while (index === this.preSelectMapIndex || index >= length) {
    //         index = Math.floor(Math.random() * length)
    //       }
    //       map.dispatchAction({
    //         type: 'mapUnSelect',
    //         seriesIndex: 0,
    //         dataIndex: this.preSelectMapIndex,
    //       })
    //       map.dispatchAction({
    //         type: 'showTip',
    //         seriesIndex: 0,
    //         dataIndex: index,
    //       })
    //       map.dispatchAction({
    //         type: 'mapSelect',
    //         seriesIndex: 0,
    //         dataIndex: index,
    //       })
    //       this.preSelectMapIndex = index
    //     } catch (error) {
    //       // console.log(error)
    //     }
    //   })
    // },
    // handleMapRandomSelect() {
    //   this.$nextTick(() => {
    //     try {
    //       const map = this.$refs.centreLeft2ChartRef.chart
    //       const _self = this
    //       setTimeout(() => {
    //         _self.reSelectMapRandomArea()
    //       }, 0)
    //       // 移入区域，清除定时器、取消之前选中并选中当前
    //       map.on('mouseover', function (params) {
    //         clearInterval(_self.intervalId)
    //         map.dispatchAction({
    //           type: 'mapUnSelect',
    //           seriesIndex: 0,
    //           dataIndex: _self.preSelectMapIndex,
    //         })
    //         map.dispatchAction({
    //           type: 'mapSelect',
    //           seriesIndex: 0,
    //           dataIndex: params.dataIndex,
    //         })
    //         _self.preSelectMapIndex = params.dataIndex
    //       })
    //       // 移出区域重新随机选中地图区域，并开启定时器
    //       map.on('globalout', function () {
    //         _self.reSelectMapRandomArea()
    //         _self.startInterval()
    //       })
    //       this.startInterval()
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   })
    // },
  },
}
</script>
<style scope>
.box {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/screen/components/map/chart.vue